import React from "react";
import { useViewport } from "@/components/providers/ViewportProvider";

export default function useRightEdgeSwipe(onSwipeOpen: () => void) {
  const touchStartX = React.useRef<number | null>(null);
  const { isMobileMode } = useViewport();

  const handleOnTouchStart = React.useCallback((e: TouchEvent) => {
    const x = e.touches[0].clientX;

    if (x > window.innerWidth - 40) {
      touchStartX.current = x;
    }
  }, []);

  const handleOnTouchEnd = React.useCallback(
    (e: TouchEvent) => {
      if (touchStartX.current === null) {
        return;
      }

      const endX = e.changedTouches[0].clientX;
      const diff = touchStartX.current - endX;

      if (diff < -50) {
        onSwipeOpen();
      }

      touchStartX.current = null;
    },
    [onSwipeOpen],
  );

  React.useEffect(() => {
    if (!isMobileMode) {
      return;
    }

    window.addEventListener("touchstart", handleOnTouchStart);
    window.addEventListener("touchend", handleOnTouchEnd);

    return () => {
      window.removeEventListener("touchstart", handleOnTouchStart);
      window.removeEventListener("touchend", handleOnTouchEnd);
    };
  }, [isMobileMode, handleOnTouchStart, handleOnTouchEnd]);
}
